import styled from "styled-components";
import { media } from "../Theme/default-theme";

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretch;
  align-items: cetner;
  padding: 0 0 2em;

  ${media.tablet} {
    padding: 1.5em 0 5.25em;
  }

  ${media.laptop} {
    padding: 0 0 7.5em;
  }
`;
